jQuery(document).ready(function () {

  let currentStep = 1;
  // Navigate to the next step
  $('.next').on('click', function (e) {
    e.preventDefault();
    const $currentStep = $(`.activePopup .step[data-step="${currentStep}"]`);
    const $nextStep = $(`.activePopup .step[data-step="${currentStep + 1}"]`);
    if ($nextStep.length) {
      $currentStep.removeClass('active');
      $nextStep.addClass('active');
      currentStep++;
    }
  });
  // Navigate to the previous step
  $('.prev').on('click', function (e) {
    e.preventDefault();
    const $currentStep = $(`.activePopup .step[data-step="${currentStep}"]`);
    const $prevStep = $(`.activePopup .step[data-step="${currentStep - 1}"]`);

    if ($prevStep.length) {
      $currentStep.removeClass('active');
      $prevStep.addClass('active');
      currentStep--;
    }
  });

  
$('.confirmWok').on('click', function (e) {
    e.preventDefault();
    var button = $(this);
    const productId = $(this).data('product-id');
    const productVariantId = $(this).data('variant-id');
    const productTitle = $(this).data('product-title');
    var targetedPopupClass = `popup-${productId}`;    
    var selectedQty = $(`#addOnQty${productId}`).val();
    var selectedSauce = $('.activePopup .SaucesBox input:checked').data('title');
    var selectedSideDish = $('.activePopup .SideDishBox input:checked').data('title');
    // Collect all selected add-ons
    const selectedItems = [];
    let addonNames = [];

   var addonSKU = '';
   var freePremeal = '';
    $(`#addonForm-${productId} input:checked`).each(function () {
        const addonId = $(this).val();
        const addonName = $(this).data('title');
        const addonPrice = $(this).data('sell');
        addonSKU = ($(this).data('product-sku')) ? $(this).data('product-sku') : addonSKU;
        freePremeal = ($(this).data('free-premeal')) ? $(this).data('free-premeal') : freePremeal; 

      // console.log(addonSKU)
        
        if (addonPrice) {
            selectedItems.push({
                id: addonId,
                quantity: selectedQty,
                properties: { 'Beilage für': productTitle + ', ' + selectedSauce }
            });
        }
      
      if(addonNames == ''){ 
         addonNames.push(addonName);
      }else{
        if(!freePremeal){
           addonNames.push(', '+addonName);
        }
      }
          // console.log(addonName)
    });
  
   if(selectedSauce && selectedSideDish){
     console.log(selectedSauce + selectedSideDish)
      if(selectedItems.length > 0){ 
        // Make a single AJAX request
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: selectedItems }),
            contentType: 'application/json',
            dataType: 'json',
            beforeSend: function() {
               button.text('Hinzufügen...');
              $('body').css('pointer-events','none');
            },
            success: function (response) {

              console.log('If first ajax success');
              console.log(response);

              setTimeout(function () {
                $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  id: productVariantId,
                  quantity: selectedQty,
                  properties: {
                    'Beilagen': addonNames,
                    'Gratis Vorspeise': freePremeal,
                    'Beilage SKU': addonSKU
                  }
                },
                dataType: 'json',
                beforeSend: function() {
                     button.text('Hinzufügen...'); 
                    $('body').css('pointer-events','none');
                  },
                success: function (data) {

                  console.log('If second ajax success');
                  console.log(response);

                  
                  fetch(`${Shopify.routes.root}cart.js`)
                      .then(response => response.json())
                      .then(cartContent => {
                        cartContent["sections"] = data["sections"]; // Assuming 'sections' comes from /cart/add.js
                        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                          bubbles: true,
                          detail: {
                            baseEvent: "variant:add",
                            cart: cartContent
                          }
                        }));

                          document.dispatchEvent(new CustomEvent("cart:refresh"));
                        
                        $('.activePopup .step').removeClass('active');
                        $('.activePopup .addonRow.step').addClass('active');
                        $('.productBlock input[type="radio"]').prop('checked', false);
                        button.text(button.data('btn-price'));
                        $('.popup-close').click();
                        $('body').css('pointer-events', 'all');
                      });
                },
                error: function (xhr, status, error) { 
                  console.error('Error adding addon:', error);
                },
              });
              }, 1000)
              
              
            },
            error: function (xhr, status, error) {
              console.error('Error adding products to cart:', error);
              alert("There was an issue adding the products to your cart. Please try again.");
            }
        });
      }else{ 

          $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  id: productVariantId,
                  quantity: selectedQty,
                  properties: {
                    'Beilagen': addonNames,
                    'Gratis Vorspeise': freePremeal,
                    'Beilage SKU': addonSKU
                  }
                },
                dataType: 'json',
                beforeSend: function() {
                     button.text('Hinzufügen...');
                    $('body').css('pointer-events','none');
                  },
                success: function (data) {

                  console.log('else ajax success'); 
                  console.log(data);

                  
                    fetch(`${Shopify.routes.root}cart.js`)
                      .then(response => response.json())
                      .then(cartContent => {
                        cartContent["sections"] = data["sections"]; // Assuming 'sections' comes from /cart/add.js
                        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                          bubbles: true,
                          detail: {
                            baseEvent: "variant:add",
                            cart: cartContent
                          }
                        }));

                          document.dispatchEvent(new CustomEvent("cart:refresh"));
                        
                        $('.activePopup .step').removeClass('active');
                        $('.activePopup .addonRow').addClass('active');
                        $('.productBlock input[type="radio"]').prop('checked', false);
                        button.text(button.data('btn-price'));
                        $('.popup-close').click(); 
                        $('body').css('pointer-events', 'all');
                      });
                  
                },
                error: function (xhr, status, error) { 
                  console.error('Error adding addon:', error);
                },
              });

      }

     
    } else {
     
      alert('Bitte Auswahl treffen, um fortzufahren.');
     
    }
 
   
});

$(document).on('click', function (e) {
    // Ensure the popup is open
    if ($('.activePopup').length && !$(e.target).closest('.popup-inner, .popupOpener').length) {
        $('.popup-close').click();
    }
});

$(document).on('click', '.popup-inner', function (e) {
    e.stopPropagation();
});



// update price at button 
  var prevVal = '';

$(document).on('click', '.activePopup .plusButtonWok', function (e) {
    prevVal = $(this).siblings('.addOnQty').val();
    
    var selectedAddon = $('.activePopup input[name="addon_03"]:checked');
    var dataProductId = selectedAddon.attr('data-product-id');
    var basePriceStr = selectedAddon.attr('data-price-base');
    var addonPriceStr = selectedAddon.attr('data-price');

    var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));
    var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));
    
    var selectedQty = $('.activePopup .addOnQty').val();
    $('#quantity-' + dataProductId).val(selectedQty);

    var totalPrice = (basePrice + addonPrice) * selectedQty;
    var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

    $('.activePopup .confirmPrice').text(formattedPrice + ' €');
});

$(document).on('click', '.activePopup .MinusButtonWok', function (e) {
    if ($(this).siblings('.addOnQty').val() > 1 || prevVal == 2) {
        var selectedAddon = $('.activePopup input[name="addon_03"]:checked');
        var dataProductId = selectedAddon.attr('data-product-id');
        var basePriceStrProduct = selectedAddon.attr('data-price-base');
        var addonPriceStr = selectedAddon.attr('data-price');

        var basePriceProduct = parseFloat(basePriceStrProduct.replace('€', '').replace(',', '.'));
        var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));
        
        var selectedQty = $('.activePopup .addOnQty').val();
        $('#quantity-' + dataProductId).val(selectedQty);

        var subtotalPrice = basePriceProduct + addonPrice;
        var totalPrice = subtotalPrice * selectedQty;
        var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

        $('.activePopup .confirmPrice').text(formattedPrice + ' €');
    }
    prevVal = $(this).siblings('.addOnQty').val();
});

$('input[name="addon_03"] , input[name="addon_02"]').on('change', function () {        
    // Get base product price and addon price from attributes
    var basePriceStr = $(this).attr('data-price'); // Addon price
    var addonPriceStr = $(this).attr('data-price-base'); // Base product price (corrected comment!)
    var dataProductId = $(this).attr('data-product-id');    
    var datasell = $(this).attr('data-sell');    


    if(datasell == "true"){

      // Parse: Remove € and handle European number formatting
      var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));
      var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));

      var selectedQty = parseInt($('.activePopup .addOnQty').val()) || 1; // fallback to 1 if null

      // Calculate total price
      var totalPrice = (addonPrice + basePrice) * selectedQty;


      // Format price for display (back to EU style with comma)
      var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

      // Update the price on the page
      $('.activePopup .confirmPrice').text(`${formattedPrice} €`);

  }
});


  
  $('input[name="addon_01"]').on('change', function () {
    $('.activePopup .next').removeClass('disabled');
  })
  
  $('input[name="addon_02"]').on('change', function () {
    $('.activePopup .next').removeClass('disabled');
  })

   $('input[name="addon"]').on('change', function () {
    $('.activePopup .confirmAddon').removeClass('disabled');
  })

    $('input[name="addon_03"]').on('change', function () {
    $('.activePopup .confirmWok').removeClass('disabled');
  })

  // Navigation buttons
  jQuery(".next").on("click", function () {
    const $currentStep = $(this).closest(".step");
    const $nextStep = $currentStep.next(".step");
    if ($nextStep.length && $currentStep.find('input[type=radio]:checked').length > 0){
      $currentStep.removeClass("active");
      $nextStep.addClass("active");
    }else{
      alert('Bitte Auswahl treffen, um fortzufahren.');
    }
  });

  jQuery(".prev").on("click", function () {
    const $currentStep = $(this).closest(".step");
    const $prevStep = $currentStep.prev(".step");

    if ($prevStep.length) {
      $currentStep.removeClass("active");
      $prevStep.addClass("active");
    }
  });

  
});
